// extracted by mini-css-extract-plugin
module.exports = {"ActiveQuiz":"_2aF-ETEz5Uw_hwqgH1nMHd","Question":"_1DBQpbIA4b48_krnabND3W"};